var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e2e1e4;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.67,0H8.33C3.74,0,0,3.74,0,8.33v23.33c0,4.59,3.74,8.33,8.33,8.33h23.33c4.59,0,8.33-3.74,8.33-8.33V8.33c0-4.59-3.74-8.33-8.33-8.33ZM20,31.67c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5ZM23.21,20.81c-.87.48-1.55,1.59-1.55,2.52s-.75,1.67-1.67,1.67-1.67-.74-1.67-1.67c0-2.14,1.35-4.38,3.27-5.44,1.27-.7,1.93-2.09,1.67-3.54-.23-1.31-1.35-2.43-2.66-2.66-1.01-.18-1.99.08-2.76.72-.76.64-1.19,1.57-1.19,2.55,0,.92-.75,1.67-1.67,1.67s-1.67-.75-1.67-1.67c0-1.97.87-3.84,2.38-5.11s3.52-1.8,5.48-1.46c2.69.47,4.9,2.68,5.37,5.37.5,2.83-.85,5.66-3.35,7.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlay);
export default __webpack_public_path__ + "static/media/how-to-play.4773242010327df721e111be74c3361e.svg";
export { ForwardRef as ReactComponent };